export default "__VITE_ASSET__K5qZxfgZ__"